import { getCookie } from '@api/HelperAPI';
import { useGetAccounts } from '@api/lendingAPI/lapiHooks';
import { FormattedMessage } from 'react-intl';

import { RCF_CASHLESS_OPENING_COOKIE } from '../../../myOffers/approvedView/RCFApprovedView/RCFApprovedView';
import {
    Step,
    StepIndicator,
    StepLabel
} from '../../../ui/components/ProgressBar/StepIndicator';

const Step1Label = ({
    isCashlessOpening,
    isTopup
}: {
    isCashlessOpening: boolean;
    isTopup: boolean;
}) => {
    if (isCashlessOpening) {
        return (
            <FormattedMessage
                id="_.funding_progess_indicator.label.adjust_offer"
                defaultMessage="Adjust offer"
            />
        );
    }
    if (isTopup) {
        return (
            <FormattedMessage
                id="_.funding_progess_indicator.label.select_amount"
                defaultMessage="Select amount"
            />
        );
    }
    return (
        <FormattedMessage
            id="_.funding_progess_indicator.label.loan_details"
            defaultMessage="Loan details"
        />
    );
};

export const FundingProgressIndicator = ({ step }: { step: number }) => {
    const { data, isLoading, isError } = useGetAccounts();

    if (isLoading || isError) return null;

    const { accounts } = data;

    if (accounts.length === 0) return null;

    const isTopup =
        accounts.filter(
            (account) => account.loan_status && account.loan_status !== 'ended'
        ).length !== 0;

    const isCashlessOpening = getCookie(RCF_CASHLESS_OPENING_COOKIE) === 'true';

    return (
        <StepIndicator className="mb-3xl">
            <Step isActive={step === 1} isComplete={step > 1}>
                <StepLabel>
                    <Step1Label
                        isCashlessOpening={isCashlessOpening}
                        isTopup={isTopup}
                    />
                </StepLabel>
            </Step>
            <Step isActive={step === 2} isComplete={step > 2}>
                <StepLabel>
                    <FormattedMessage
                        id="_.funding_progess_indicator.label.final_checks"
                        defaultMessage="Final checks"
                    />
                </StepLabel>
            </Step>
            <Step isActive={step === 3}>
                <StepLabel>
                    {isCashlessOpening ? (
                        <FormattedMessage
                            id="_.funding_progess_indicator.label.gain_access"
                            defaultMessage="Gain access"
                        />
                    ) : (
                        <FormattedMessage
                            id="_.funding_progess_indicator.label.withdraw_funds"
                            defaultMessage="Withdraw funds"
                        />
                    )}
                </StepLabel>
            </Step>
        </StepIndicator>
    );
};
